export default __webpack_public_path__ + "img/homepage.commitment.04.asset.38a619fc.jpg";